"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const fleetData = [{
  id: 1,
  name: "Midnight Echoes",
  type: "Studio Album",
  capacity: "Rhythm & Soul",
  features: "Executive Production • Mixing",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_midnight_echoes.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_midnight_echoes.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_midnight_echoes.png-wvc-sizes",
  link: "/PortfolioPage"
}, {
  id: 2,
  name: "Concrete Jungle",
  type: "EP Release",
  capacity: "The Urban Collective",
  features: "Beat Licensing • Mastering",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_concrete_jungle.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_concrete_jungle.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_concrete_jungle.png-wvc-sizes",
  link: "/PortfolioPage"
}, {
  id: 3,
  name: "Velvet Soul",
  type: "Lp",
  capacity: "Satin & Silk",
  features: "Vocal Arrangement • Production",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_velvet_soul.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_velvet_soul.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_velvet_soul.png-wvc-sizes",
  link: "/PortfolioPage"
}];
export default function TheDiscography() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="242507" id="the-discography" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`mb-16 md:mb-24 text-center transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter mb-6 uppercase">
            The Discography
          </h2>
          <p className="font-mono text-muted-foreground max-w-2xl mx-auto text-sm uppercase tracking-widest">
            A sonic archive of curated productions, defining the intersection of rhythm and soul.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {fleetData.map((vehicle, index) => <FleetCard key={vehicle.id} vehicle={vehicle} index={index} />)}
        </div>
      </div>
    </section>;
}
function FleetCard({
  vehicle,
  index
}: {
  vehicle: typeof fleetData[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const delay = index * 150;
  return <div ref={ref} data-index={index} className={`group flex flex-col gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${delay}ms`
  }}>
      <div className="relative overflow-hidden rounded-md bg-card shadow-lg">
        <AspectRatio ratio={4 / 3}>
          <img src={vehicle.imageSrc} data-wvc-srcset={vehicle.imageSrcset} data-wvc-sizes={vehicle.imageSizes} alt={vehicle.name} loading="lazy" className="object-cover w-full h-full grayscale transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0" />
          {}
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-80 pointer-events-none" />
        </AspectRatio>
      </div>

      <div className="flex flex-col items-start">
        <h3 className="font-default text-3xl md:text-4xl font-bold tracking-tighter text-foreground mb-2 uppercase">
          {vehicle.name}
        </h3>
        <p className="font-mono text-xs text-muted-foreground uppercase tracking-widest mb-6">
          {vehicle.capacity} <span className="mx-2 opacity-30">/</span> <span className="italic">{vehicle.type}</span>
        </p>

        <div className="mt-auto overflow-hidden">
          <div className="opacity-0 -translate-y-4 transition-all duration-500 ease-out group-hover:opacity-100 group-hover:translate-y-0">
            <Link to={vehicle.link} className="group/link inline-flex items-center gap-2 font-mono text-xs font-bold text-primary uppercase tracking-widest relative pb-1">
              Listen Now
              <ArrowRight className="w-3 h-3 transition-transform duration-300 group-hover/link:translate-x-1" />
              <span className="absolute bottom-0 left-0 w-full h-[2px] bg-primary origin-right scale-x-0 transition-transform duration-300 ease-out group-hover/link:origin-left group-hover/link:scale-x-100" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
}